namespace Portico.Services {

	import Inject = Portico.Decorators.Inject;
	import Service = Portico.Decorators.Service;

	import pm = Portico.Models;
	import pme = Portico.Models.Enterprise;
	import pmi = Portico.Models.Interfaces;
	import pms = Portico.Models.Setup;
	import ps = Portico.Services;

	enum ModalState {
		HIDDEN,
		HIDE,
		SHOW,
		SHOWN
	}

	export class Modal {
		id: string;
		actualId: string;
		version: number;
		$scope: angular.IScope;
		html: string;
		returnTo: JQuery;
		state: ModalState;

		constructor(id: string, actualId: string, version: number = 1, $scope: angular.IScope = null, html: string = null) {
			this.id = id;
			this.actualId = actualId;
			this.version = version;
			this.$scope = $scope;
			this.html = html;
			this.returnTo = null;
			this.state = ModalState.SHOW;
		}
	}

	export interface IModalService {
		clear: () => void;
		hide: (id: string) => void;
		hide2: (key: string) => void;
		show: (id: string) => void;
		show2: ($scope: angular.IScope, key: string, clazz?: string, ngInit?: string) => void;
	}

    @Service('app', 'modalService')
	@Inject('$compile', '$timeout')
	export class ModalService implements IModalService {
		private current: number;
		private modals: Modal[];
		private ready: boolean;

		constructor(
			private $compile: ng.ICompileService,
			private $timeout: ng.ITimeoutService
		) {
			this.current = 0;
			this.modals = [];
			this.ready = true;
		}

		public clear(): void {
			this.current = 0;
			this.modals = [];
			this.ready = true;
		}

		public hide(id: string): void {
			const modal = _.findLast(this.modals, (m) => { return m.id === id && m.state !== ModalState.HIDDEN && m.version === 1; });
			modal.state = modal.state === ModalState.SHOWN ? ModalState.HIDE : ModalState.HIDDEN;
			this._process();
		}

		public hide2(key: string): void {
			const modal = _.findLast(this.modals, (m) => { return m.id === key && m.state !== ModalState.HIDDEN && m.version === 2; });
			modal.state = modal.state === ModalState.SHOWN ? ModalState.HIDE : ModalState.HIDDEN;
			this._process();
		}

		public show(id: string): void {
			const actualId = $(`#${id}`).hasClass('modal') ? `#${id}` : '#default-spinner';
			const modal = new Modal(id, actualId);
			this.modals.push(modal);
			this._process();
		}

		public show2($scope: angular.IScope, key: string, clazz: string = '', ngInit: string = ''): void {
			const actualId = `#${key}`;
			const html = `<tc-modal clazz="${clazz}" key="${key}" ng-init="${ngInit}" />`;
			const modal = new Modal(key, actualId, 2, $scope, html);
			this.modals.push(modal);
			this._process();
		} 

		private _process(): void {
			if (this.ready) {
				this.modals = this.modals.filter((m, index) => { return m.state !== ModalState.HIDDEN || index < this.current; });

				if (this.current < this.modals.length) {
					if (this.current < this.modals.length - 1 || this.modals[this.current].state === ModalState.HIDE) {
						const modal = this.modals[this.current];
						modal.state = modal.state === ModalState.HIDE ? modal.state = ModalState.HIDDEN : ModalState.SHOW;

						$(modal.actualId).one('hidden.bs.modal', (e) => {
							modal.returnTo.focus();
							const index = _.findLastIndex(this.modals, (m) => { return m.state === ModalState.SHOW; });
							this.current = index >= 0 ? index : 0;
							this.ready = true;
							this._process();
						});

						this.ready = false;
						$(modal.actualId).modal('hide');
					} else if (this.modals[this.current].state === ModalState.SHOW) {
						const modal = this.modals[this.current];
						modal.returnTo = $(":focus").first();
						modal.state = ModalState.SHOWN;

						if (modal.version === 2) {
							const element = $(`#modal-container`).html(modal.html);
							this.$compile(element.contents() as any)(modal.$scope);
						}

						$(modal.actualId).one('shown.bs.modal', (e) => {
							$(modal.actualId).find("a, button, input, select, textarea").first().focus();

							this.ready = true;
							this._process();
						});

						this.ready = false;
						$(modal.actualId).modal('show');
					}
				}
			}
		} 
    }
}